const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const userTime = new Date(new Date().toLocaleString('en-US', {timeZone: userTimeZone}));

function formatTime(gameStartTime, userTime) {
  const milliseconds = Math.abs(userTime - gameStartTime);
  const seconds = Math.floor(milliseconds / 1000);
  const days = Math.floor(Math.floor(seconds / 3600) / 24);
  let hours = Math.floor(seconds / 3600) - 24 * days;
  let minutes = Math.floor((seconds % 3600) / 60);
  let remainingSeconds = seconds % 60;
  const textPluralDays = (days < 1) ? '' : (days >= 2) ? days + ' days ' : days + ' day '
  hours = hours < 10 ? '0' + hours : hours;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  remainingSeconds = remainingSeconds < 10 ? '0' + remainingSeconds : remainingSeconds;
  return (textPluralDays + hours + ':' + minutes + ':' + remainingSeconds);
}

export function setTournamentTimer(gameStartTime, gameEndTime) {
  gameStartTime = new Date(gameStartTime  * 1000);
  gameEndTime = new Date(gameEndTime  * 1000);
  const timer = document.querySelector('.tournament-timer');
  if (userTime - gameStartTime >= 0 && userTime - gameEndTime <= 0) {
    setInterval(function () {
      if (timer) {
        timer.textContent = formatTime(gameEndTime, new Date(new Date().toLocaleString('en-US', {timeZone: userTimeZone})));
      }
    }, 1000);
  }
}


